import { render, staticRenderFns } from "./OSWindow.vue?vue&type=template&id=ee406f8e&scoped=true"
import script from "./OSWindow.vue?vue&type=script&lang=js"
export * from "./OSWindow.vue?vue&type=script&lang=js"
import style0 from "./OSWindow.vue?vue&type=style&index=0&id=ee406f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee406f8e",
  null
  
)

export default component.exports